import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import styles from './footer.styles';
import CloseIcon from '../../assets/close_white.svg';
import { VERSION_NUMBER, ENVIRONMENT } from '../../configurations';

type PropType = {
  classes: Object,
}

type StateType = {
  show: boolean,
}

export class FooterC extends React.PureComponent<PropType, StateType> {

  state = {
    show: true,
  }

  hide = () => {
    this.setState({ show: false });
  }

  render() {
    const { classes } = this.props;
    const { show } = this.state;
    return (
      (show)
        ? (
          <div className={classes.root}>
            {`${String(ENVIRONMENT)} Version: ${VERSION_NUMBER}`}
            <CloseIcon className={classes.close} onClick={this.hide} />
          </div>
        )
        : (
          <div className={classes.hide} />
        )
    );
  }

}

export default withStyles(styles)(FooterC);
